'use strict';

export const SIGNED_URL_EXPIRATION_BUFFER = 5;
